import Grid from 'components/Grid';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ApplicationsGridRowWrapper: FunctionComponent<Props> = ({
    children,
    ref,
    style,
    testId = TEST_ID
}) => (
    <Grid className={styles.applicationsGridRowWrapper} ref={ref} style={style} testId={testId}>
        {children}
    </Grid>
);

export default ApplicationsGridRowWrapper;
